module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/thanks.json
// module id = 339
// module chunks = 229114350069216